import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Package, Mail, Lock } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { BACKEND_URL } from "../config/api";

// BACKEND_URL imported from config/api

const TeamMemberLogin = () => {
  const [orgSlug, setOrgSlug] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!orgSlug || !username || !password) {
      toast.error("Please enter organization slug, username and password");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/org-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orgSlug: orgSlug.toLowerCase().trim(),
          username,
          password
        })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Login failed');
      }
      
      const data = await response.json();
      
      // Store team member info and JWT token
      localStorage.setItem('jwtToken', data.token);
      localStorage.setItem('userType', 'teamMember');
      localStorage.setItem('userData', JSON.stringify(data.user || data.teamMember || {}));
      localStorage.setItem('organizationId', data.organizationId);
      localStorage.setItem('organizationName', data.organizationName || '');
      localStorage.setItem('organizationSlug', data.organizationSlug || orgSlug);
      
      toast.success(`Welcome back, ${data.user?.name || data.teamMember?.name || username}!`);
      navigate("/dashboard");
      
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{background: 'linear-gradient(to bottom right, #eff6ff, #dbeafe)'}}>
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-4 rounded-xl shadow-lg" style={{background: '#007AFF'}}>
              <Package className="w-10 h-10 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold" style={{color: '#1a1a1a'}}>
            Charter <span style={{color: '#007AFF'}}>Share</span>
          </CardTitle>
          <p className="text-gray-600 mt-2">TeamMember Login</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="orgSlug" className="flex items-center gap-2">
                <Package className="w-4 h-4" />
                Organization Slug
              </Label>
              <Input
                id="orgSlug"
                type="text"
                value={orgSlug}
                onChange={(e) => setOrgSlug(e.target.value)}
                placeholder="e.g., mycompany"
                disabled={loading}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="username" className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                Username
              </Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                disabled={loading}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="password" className="flex items-center gap-2">
                <Lock className="w-4 h-4" />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                disabled={loading}
                className="mt-1"
              />
            </div>
            <Button
              type="submit"
              className="w-full py-6 text-lg font-semibold"
              style={{background: '#007AFF'}}
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
            <div className="text-center text-sm text-gray-600 mt-4 pt-4 border-t">
              Don't have an account?{' '}
              <button
                type="button"
                onClick={() => navigate('/teamMember-signup')}
                className="text-blue-600 hover:underline font-medium"
              >
                Sign up here
              </button>
            </div>
            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate('/')}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                ← Back to main site
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default TeamMemberLogin;